/** Helpers for links a parent sends to someone else (report links, family invites). */

export const shareUrl = (path: string): string => `${window.location.origin}${path}`;

export const whatsappHref = (text: string): string => `https://wa.me/?text=${encodeURIComponent(text)}`;

export const mailtoHref = (subject: string, body: string, to = ''): string =>
  `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

/** Copies text; falls back to a hidden textarea where the async clipboard is unavailable. */
export const copyText = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      const ok = document.execCommand('copy');
      area.remove();
      return ok;
    } catch {
      return false;
    }
  }
};
